export const instruerandeTextRubrics = [
	{
		name: "Instruerande text",
		grade: "åk3",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Enkla men exakta instruktioner 2) Anger viktiga mått/antal 3) Förklarar svåra ord",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Några mått/antal 3) Vissa ordförklaringar",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga instruktioner 2) Något mått anges",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått/antal",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig ordning med numrering 2) Minst fem steg 3) Enkel rubrik",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Numrerade steg 2) Fyra steg 3) Rubrik",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tre steg 2) Viss ordning 3) Enkel rubrik",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Steg 3) Rubrik",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Lista på allt material 2) Säkerhetsregler 3) Tydlig start och slut",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Material anges 2) Enkel säkerhet 3) Start finns",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Några material anges 2) Start finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Start",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Enkelt och tydligt språk 2) Bilder/teckning 3) Rätt tempus",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Någon bild 3) Oftast rätt tempus",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripligt språk 2) Försök till tempus",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Tempus",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "åk4",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Exakta instruktioner 2) Alla mått/antal 3) Förklarar svåra ord 4) Extra tips",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Viktiga mått/antal 3) Några ordförklaringar",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga instruktioner 2) Några mått anges",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått/antal",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig numrering 2) Sex-sju steg 3) Informativ rubrik",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Numrerade steg 2) Fem steg 3) Tydlig rubrik",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fyra steg 2) Viss ordning 3) Rubrik",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Steg 3) Rubrik",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplett materiallista 2) Säkerhetsregler 3) Tydlig start och slut 4) Tips",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Material anges 2) Enkel säkerhet 3) Start och slut",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Viktiga material anges 2) Start finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Start/slut",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydligt språk 2) Bilder/teckning 3) Rätt tempus 4) Bindeord",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra språk 2) Någon bild 3) Mestadels rätt tempus",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Oftast rätt tempus",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Rätt tempus",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "åk5",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Detaljerade instruktioner 2) Alla mått/antal/tider 3) Ordförklaringar 4) Förtydligande exempel",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Viktiga mått/antal 3) Några ordförklaringar",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga instruktioner 2) Vissa mått anges",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått/antal",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig numrering 2) Sju-åtta steg 3) Delrubriker 4) Logisk ordning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Numrerade steg 2) Sex steg 3) Tydlig rubrik",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fem steg 2) Viss ordning 3) Rubrik",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Steg 3) Rubrik",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Detaljerad materiallista 2) Säkerhetsregler 3) Start och slut 4) Tips och alternativ",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Material anges 2) Säkerhet nämns 3) Start och slut",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Material anges 2) Start och slut finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Start/slut",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist språk 2) Bilder/diagram 3) Korrekt tempus 4) Bindeord",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Visual stöd 3) Rätt tempus",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Oftast rätt tempus",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Rätt tempus",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "åk6",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Utförliga instruktioner 2) Exakta mått/antal/tider 3) Ordförklaringar 4) Förtydligande exempel 5) Tips",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Viktiga mått/antal 3) Ordförklaringar",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga instruktioner 2) Vissa mått anges 3) Enkel förklaring",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått/antal",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig numrering 2) Åtta-nio steg 3) Delrubriker 4) Perfekt ordning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Numrerade steg 2) Sju steg 3) Rubriker",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Sex steg 2) Viss ordning 3) Rubrik",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Steg 3) Rubrik",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplett materiallista 2) Säkerhetsregler 3) Tydlig struktur 4) Alternativ 5) Tips",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Material anges 2) Säkerhet nämns 3) Struktur",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Material anges 2) Enkel struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Struktur",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist språk 2) Bilder/diagram 3) Perfekt tempus 4) Bindeord 5) Layout",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Visuellt stöd 3) Rätt tempus",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Oftast rätt tempus",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Rätt tempus",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "åk7",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Detaljerade instruktioner 2) Exakta mått/antal/tider 3) Omfattande ordförklaringar 4) Förtydligande exempel 5) Alternativa metoder",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Relevanta mått/antal 3) Ordförklaringar 4) Exempel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga instruktioner 2) Vissa mått anges 3) Enkel förklaring",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått/antal 3) Förklaringar",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig numrering 2) Nio-tio steg 3) Informativa delrubriker 4) Logisk gruppering 5) Perfekt ordning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Numrerade steg 2) Åtta steg 3) Delrubriker 4) God ordning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Sju steg 2) Viss ordning 3) Enkel rubrik",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Steg 3) Rubrik",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Detaljerad materiallista 2) Utförliga säkerhetsregler 3) Alternativa material 4) Tydlig struktur 5) Praktiska tips",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig materiallista 2) Säkerhetsregler 3) Struktur 4) Tips",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Material anges 2) Viss säkerhet 3) Enkel struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Säkerhet 3) Struktur",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist språk 2) Effektiva illustrationer 3) Konsekvent tempus 4) Avancerade bindeord 5) Genomtänkt layout",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Relevanta bilder 3) Rätt tempus 4) Bindeord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Något visuellt stöd 3) Oftast rätt tempus",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Visuellt stöd 3) Rätt tempus",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "åk8",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mycket detaljerade instruktioner 2) Alla relevanta mått/antal/tider 3) Omfattande ordförklaringar 4) Flera förtydligande exempel 5) Alternativa metoder 6) Felsökning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Relevanta mått/antal 3) Ordförklaringar 4) Exempel 5) Någon alternativ metod",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga instruktioner 2) Vissa mått anges 3) Enkla förklaringar 4) Exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått/antal 3) Förklaringar",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig numrering 2) Tio-tolv steg 3) Informativa delrubriker 4) Logisk gruppering 5) Perfekt ordning 6) Överblick",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Numrerade steg 2) Nio steg 3) Delrubriker 4) God ordning 5) Struktur",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Åtta steg 2) Viss ordning 3) Rubrik 4) Enkel struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Steg 3) Rubrik 4) Struktur",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplett materiallista 2) Utförliga säkerhetsregler 3) Flera alternativa material 4) Tydlig struktur 5) Praktiska tips 6) Kostnadsaspekter",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig materiallista 2) Säkerhetsregler 3) Alternativ 4) Struktur 5) Tips",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Material anges 2) Viss säkerhet 3) Enkel struktur 4) Något tips",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Säkerhet 3) Struktur 4) Tips",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mycket precist språk 2) Effektiva illustrationer 3) Perfekt tempus 4) Avancerade bindeord 5) Genomtänkt layout 6) Tekniska termer",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Relevanta bilder 3) Rätt tempus 4) Bindeord 5) Layout",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Visuellt stöd 3) Oftast rätt tempus 4) Enkla bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Visuellt stöd 3) Rätt tempus 4) Bindeord",
					},
				],
			},
		],
	},

	{
		name: "Instruerande text",
		grade: "åk9",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Exakta och detaljerade instruktioner 2) Tydliga mått/antal/tider 3) Förutser och förklarar svårigheter 4) Omfattande förklaringar av facktermer",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Relevanta mått/antal 3) Förklarar facktermer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga instruktioner 2) Vissa mått/antal anges 3) Enkel förklaring av termer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Nödvändiga mått/antal 3) Förklaringar",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Logisk stegvis progression 2) Tydlig numrering/punkter 3) Effektiva delrubriker 4) Genomtänkt gruppering av moment",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Klar ordningsföljd 2) Numrering/punkter 3) Använder rubriker",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande ordning 2) Enkel numrering 3) Viss struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Logisk ordning 2) Numrering 3) Struktur",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Utförlig materiallista 2) Alternativa metoder/material 3) Säkerhetsanvisningar 4) Perfekt anpassad svårighetsnivå",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig materiallista 2) Några alternativ 3) Grundläggande säkerhet",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel materiallista 2) Basala instruktioner 3) Viss anpassning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Materiallista 2) Anpassning 3) Säkerhet",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist och konsekvent språk 2) Effektiva visuella hjälpmedel 3) Tydliga tidsmarkörer 4) Korrekt tempusanvändning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydligt språk 2) Några visuella stöd 3) Fungerande tempus",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkelt språk 2) Viss visualisering 3) Mestadels rätt tempus",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Visuella stöd 3) Korrekt tempus",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "firstRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Avancerade och exakta instruktioner 2) Omfattande mått/antal/tider 3) Akademiska ordförklaringar 4) Expertförklaringar 5) Flera metodalternativ 6) Metodkritik",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Detaljerade instruktioner 2) Relevanta mått/antal 3) Facktermer förklaras 4) Exempel 5) Alternativa metoder",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Grundläggande mått 3) Vissa förklaringar 4) Exempel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått/antal 3) Förklaringar",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Avancerad stegvis struktur 2) Tolv-femton steg 3) Akademiska delrubriker 4) Logisk gruppering 5) Perfekt progression 6) Metastruktur",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Tydlig struktur 2) Tio-tolv steg 3) Delrubriker 4) God ordning 5) Överblick",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nio-tio steg 2) Grundordning 3) Rubriker 4) Viss struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Tillräckliga steg 3) Rubriker 4) Struktur",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Professionell materiallista 2) Omfattande säkerhetsprotokoll 3) Flera materialalternativ 4) Akademisk struktur 5) Expertråd 6) Kostnadsanalys 7) Miljöaspekter",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Detaljerad materiallista 2) Säkerhetsregler 3) Alternativ 4) Tydlig struktur 5) Tips",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Basmaterial anges 2) Grundläggande säkerhet 3) Struktur 4) Tips",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Säkerhet 3) Struktur 4) Tips",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Akademiskt språk 2) Professionella illustrationer 3) Perfekt tempus 4) Avancerade bindeord 5) Expertlayout 6) Fackterminologi 7) Källhänvisningar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Precist språk 2) Tydliga bilder 3) Korrekt tempus 4) Bindeord 5) God layout",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydligt språk 2) Visuellt stöd 3) Mestadels rätt tempus 4) Enkla bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Visuellt stöd 3) Rätt tempus 4) Bindeord",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "secondRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Expertinstruktioner 2) Fullständiga mått/data 3) Vetenskapliga förklaringar 4) Djupgående analys 5) Metoddiskussion 6) Felanalys 7) Kvalitetssäkring",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Avancerade instruktioner 2) Omfattande mått 3) Akademiska förklaringar 4) Metodval 5) Analys",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydliga instruktioner 2) Relevanta mått 3) Förklaringar 4) Enkel analys",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Mått 3) Förklaringar 4) Analys",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Vetenskaplig struktur 2) Femton-arton steg 3) Teoretisk inramning 4) Perfekt progression 5) Metaanalys 6) Kvalitetskontroll 7) Metodreflektion",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Avancerad struktur 2) Tolv-femton steg 3) Akademiska rubriker 4) God progression 5) Analys",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tio-tolv steg 2) Tydlig ordning 3) Rubriker 4) Struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Tillräckliga steg 3) Rubriker 4) Struktur",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Vetenskaplig materiallista 2) Säkerhetsprotokoll 3) Materialanalys 4) Vetenskaplig struktur 5) Expertråd 6) Kostnadseffektivitet 7) Hållbarhetsanalys 8) Kvalitetskrav",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Avancerad materiallista 2) Säkerhetsregler 3) Alternativ 4) Akademisk struktur 5) Analys",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydlig materiallista 2) Säkerhet 3) Struktur 4) Råd",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Säkerhet 3) Struktur 4) Råd",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Vetenskapligt språk 2) Professionell visualisering 3) Perfekt tempus 4) Avancerade bindeord 5) Vetenskaplig layout 6) Fackterminologi 7) Referenser 8) Metodterminologi",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Akademiskt språk 2) Tydliga illustrationer 3) Korrekt tempus 4) Avancerade bindeord 5) Akademisk layout",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydligt språk 2) Visuellt stöd 3) Rätt tempus 4) Bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Visuellt stöd 3) Rätt tempus 4) Bindeord",
					},
				],
			},
		],
	},
	{
		name: "Instruerande text",
		grade: "thirdRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Tydlighet och precision",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Forskningsnivå instruktioner 2) Omfattande datainsamling 3) Teoretisk grund 4) Metodologisk diskussion 5) Kritisk analys 6) Kvalitetssäkring 7) Vetenskaplig validering 8) Forskningsanknytning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Expertinstruktioner 2) Detaljerad data 3) Teoretiska kopplingar 4) Metodanalys 5) Validering",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Avancerade instruktioner 2) Relevant data 3) Förklaringar 4) Analys",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydliga instruktioner 2) Data 3) Förklaringar 4) Analys",
					},
				],
			},
			{
				name: "Struktur och ordningsföljd",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Forskningsbaserad struktur 2) Arton-tjugo steg 3) Teoretiskt ramverk 4) Metodologisk progression 5) Vetenskaplig analys 6) Kvalitetskontroll 7) Metoddiskussion 8) Forskningsanknytning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Vetenskaplig struktur 2) Femton-arton steg 3) Teoretiska rubriker 4) Metodisk progression 5) Analys",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tolv-femton steg 2) Akademisk ordning 3) Rubriker 4) Struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Ordning 2) Tillräckliga steg 3) Rubriker 4) Struktur",
					},
				],
			},
			{
				name: "Målgruppsanpassning och material",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Forskningskvalitet materiallista 2) Säkerhetsprotokoll 3) Materialanalys 4) Forskningsstruktur 5) Vetenskapliga råd 6) Ekonomisk analys 7) Hållbarhetsperspektiv 8) Kvalitetskriterier 9) Metodvalidering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Vetenskaplig materiallista 2) Säkerhetsrutiner 3) Alternativ 4) Vetenskaplig struktur 5) Expertanalys",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Avancerad materiallista 2) Säkerhet 3) Struktur 4) Analys",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Material 2) Säkerhet 3) Struktur 4) Analys",
					},
				],
			},
			{
				name: "Språk och presentation",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Forskningsspråk 2) Vetenskaplig visualisering 3) Perfekt tempus 4) Akademiska bindeord 5) Forskningslayout 6) Ämnesspecifik terminologi 7) Källhänvisningar 8) Metodterminologi 9) Teoretisk förankring",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Vetenskapligt språk 2) Professionella illustrationer 3) Korrekt tempus 4) Vetenskapliga bindeord 5) Vetenskaplig layout",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Akademiskt språk 2) Visuellt stöd 3) Rätt tempus 4) Avancerade bindeord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Akademiskt språk 2) Visuellt stöd 3) Rätt tempus 4) Bindeord",
					},
				],
			},
		],
	},
];
